import React, { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

interface AuthContextType {
    name: string;
    email: string;
    isAdmin: boolean;
    isManager: boolean;
}

const AuthContext = createContext<AuthContextType>({
    name: "",
    email: "",
    isAdmin: false,
    isManager: false
});

export const AuthProvider = ({ children }: any) => {
    const { accounts } = useMsal();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [isManager, setIsManager] = useState(false);

    useEffect(() => {
        if (accounts.length === 0) return;

        const account = accounts[0];

        setName(account.name || "");
        setEmail(account.username || "");

        // 🔥 GROUPS FROM ID TOKEN CLAIMS (CORRECT WAY)
        const groups: string[] =
            (account.idTokenClaims as any)?.groups || [];


        const ADMIN_GROUP = "d1495d18-0cac-435f-ad46-9ea9c953e758";
        const MANAGER_GROUP = "1641f879-442c-4bcd-8701-e678531797cc";

        setIsAdmin(groups.includes(ADMIN_GROUP));
        setIsManager(groups.includes(MANAGER_GROUP));

    }, [accounts]);

    return (
        <AuthContext.Provider value={{ name, email, isAdmin, isManager }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);